import React from 'react';
import type { SystemStage } from '../../data/partnershipBrief';
interface SystemSwimlaneProps {
  stages: SystemStage[];
}
const laneLabel = 'text-[11.5px] font-bold uppercase tracking-[0.12em] leading-tight';

/**
 * How the system works, as two swim lanes under a numbered track: the top
 * lane is what D2D HIRE runs, the bottom lane what the partner's team owns.
 * One grid, so every stage's lanes share a top and bottom edge however the
 * text wraps.
 */
export function SystemSwimlane({
  stages
}: SystemSwimlaneProps) {
  const columns = `104px repeat(${stages.length}, minmax(0, 1fr))`;
  const lanes = [{
    key: 'we',
    title: 'D2D HIRE runs',
    labelClass: 'text-[#14684d]',
    cellClass: 'bg-[#e2f3ea]',
    mark: 'text-[#14684d]',
    items: (stage: SystemStage) => stage.we
  }, {
    key: 'you',
    title: 'Your team owns',
    labelClass: 'text-[#4a5560]',
    cellClass: 'bg-[#f1f3f4]',
    mark: 'text-[#4a5560]',
    items: (stage: SystemStage) => stage.you
  }];
  return <div className="grid gap-x-2.5" style={{
    gridTemplateColumns: columns
  }} data-id="element-895" data-mp="178qbvdh2nvys">
      {/* Track: the stages in order, left to right. */}
      <div aria-hidden="true" data-id="element-896" data-mp="1g9xwwtukv0ax" />
      {stages.map((stage, index) => <div key={stage.title} className="pb-2.5 pr-1" data-id="element-897" data-mp="1g7lfqiwn8tyx" data-mpi={index}>
          <div className="flex items-center" data-id="element-898" data-mp="1l7py6eh43yrs">
            <span className="brief-display flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#14684d] text-[14px] font-extrabold text-white" data-id="element-899" data-mp="1l6ewck78913b">
              {index + 1}
            </span>
            {index < stages.length - 1 && <span className="ml-2 h-[2px] flex-1 bg-[#14684d]/25" aria-hidden="true" data-id="element-900" data-mp="xi5eftd4wxhg" />}
          </div>
          {stage.when && <div className="mt-2 text-[11.5px] font-bold uppercase tracking-[0.1em] text-[#14684d]" data-id="element-901" data-mp="12bzsag626i8m">
              {stage.when}
            </div>}
          <div className={`brief-display ${stage.when ? 'mt-0.5' : 'mt-2'} text-[16.5px] font-bold leading-tight`} data-id="element-902" data-mp="9skkkffg0fte">
            {stage.title}
          </div>
          <p className="mt-1 text-[13.5px] leading-[1.45] text-[#2c3640]" data-id="element-903" data-mp="3twp3w3cruz3a">
            {stage.what}
          </p>
        </div>)}

      {lanes.map((lane, laneIndex) => <React.Fragment key={lane.key} data-id="element-904" data-mp="bktz4gkc4uuu" data-mpi={laneIndex}>
          <div className={`${laneLabel} ${lane.labelClass} flex items-center pr-2 ${laneIndex === 1 ? 'mt-1.5' : ''}`} data-id="element-905" data-mp="6j4qf7kl4t9x">
            {lane.title}
          </div>
          {stages.map(stage => <ul key={stage.title} className={`rounded-md px-3 py-2 space-y-0.5 ${lane.cellClass} ${laneIndex === 1 ? 'mt-1.5' : ''}`} data-id="element-906" data-mp="3aywapsrya3j3">
              {lane.items(stage).map(item => <li key={item} className="flex gap-1.5 text-[13px] leading-snug" data-id="element-907" data-mp="3jx83o1gahdep">
                  <span className={`font-bold ${lane.mark}`} aria-hidden="true" data-id="element-908" data-mp="145tvxrehxo0j">
                    ✓
                  </span>
                  <span data-id="element-909" data-mp="zaoccz8kglfm">{item}</span>
                </li>)}
            </ul>)}
        </React.Fragment>)}
    </div>;
}